import { render, staticRenderFns } from "./GenerateTestPaperSetting.vue?vue&type=template&id=7b8bc152&scoped=true&"
import script from "./GenerateTestPaperSetting.vue?vue&type=script&lang=js&"
export * from "./GenerateTestPaperSetting.vue?vue&type=script&lang=js&"
import style0 from "./GenerateTestPaperSetting.vue?vue&type=style&index=0&id=7b8bc152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bc152",
  null
  
)

export default component.exports